import {
  GatewayAssujetti,
  GatewayFormationContinue,
  GatewayInfoSocieteOrias,
} from "@conformite/gateway";
import { Form } from "@endya-conformite/ui-kit";
import { GatewayFormationContinueApi } from "@src/api/conformite/formationContinue.api";
import {
  ConformiteFormFormationIasContent,
  useFormationContinueIasForm,
} from "@src/assujettis/AssujettiPaneContent/pages/AssujettiParcoursConformite/Steps/FormsFormation/ConformiteFormFormationIAS/ConformiteFormFormationIasContent";
import { FieldSet } from "@src/components/FieldSet/FieldSet";
import { useCallback } from "react";
import { ControleQuinquennalFormTitle } from "./ControleQuinquennalFormTitle";
import { useControleQuinquennalForm } from "./useControleQuinquennalForm";

export const useFormationContinueIas = (
  assujetti: GatewayAssujetti.AssujettiWithAvancement | undefined,
  needed: boolean
) => {
  const call = useCallback(() => {
    if (!assujetti) return Promise.resolve(null);
    return GatewayFormationContinueApi.getIasAdmin(
      assujetti.id,
      assujetti.millesime
    );
  }, [assujetti]);
  const { content, hasLoaded } = useControleQuinquennalForm(
    assujetti,
    needed,
    call
  );
  return {
    formationContinueIas: content,
    hasLoadedFormationContinueIas: hasLoaded,
  };
};
type ControleQuinquennalAssujettiSidePaneContentFormationContinueIasProps = {
  assujetti: GatewayAssujetti.AssujettiWithAvancement;
  formationContinue: GatewayFormationContinue.FormationContinueIas | null;
  categories: GatewayInfoSocieteOrias.Categorie[];
  categoriesAccessoires: GatewayInfoSocieteOrias.Categorie[];
};

export function ControleQuinquennalAssujettiSidePaneContentFormationContinueIas({
  assujetti,
  formationContinue,
  categories,
  categoriesAccessoires,
}: ControleQuinquennalAssujettiSidePaneContentFormationContinueIasProps) {
  const props = useFormationContinueIasForm(
    formationContinue,
    categories,
    categoriesAccessoires
  );
  return (
    <>
      <ControleQuinquennalFormTitle
        assujetti={assujetti}
        title="Formation Continue IAS"
        avancement="formationContinueIas"
      />
      <Form formConfig={props.formConfig} onSubmit={() => null}>
        <FieldSet disabled>
          <ConformiteFormFormationIasContent
            {...props}
            data={{ assujetti }}
            hideTitle
          />
        </FieldSet>
      </Form>
    </>
  );
}
